class CalendarConfig {

    page: any = null;
    pageStart: any = null;
    pageEnd: any = null;
    pageSize: any;
    pageState: string;
    navPreviousPage: boolean = false;
    navNextPage: boolean = false;

    constructor(pageSize: string, pageState: string, navPreviousPage: boolean, navNextPage: boolean) {
        this.pageSize = pageSize;
        this.pageState = pageState;
        this.navPreviousPage = navPreviousPage;
        this.navNextPage = navNextPage;
    }

    /**
    * @return {string}
    */
    getPageSize() : string {
      return this.pageSize;
    }

    /**
    * @return {string}
    */
    getPageState() : string {
      return this.pageState;
    }

    /**
    * @return {boolean}
    */
    getNavPreviousPage() : boolean {
      return this.navPreviousPage;
    }

    /**
    * @return {boolean}
    */
    getNavNextPage() : boolean {
      return this.navNextPage;
    }

    /**
    * @param {string} formatFor 
    * @return {string}
    */
    getHeaderDateFormat(formatFor:string) : string {
        switch(formatFor) {
            case 'month':
                return 'MMMM YYYY';

            case 'year':
                return 'YYYY';

            default:
                return formatFor;
        }
    }

    /**
    * @param {string} formatFor 
    * @return {string}
    */
    getItemDateFormat(formatFor: string) : string {
        switch(formatFor) {
            case 'month':
                return 'D';

            case 'year':
                return 'dddd, Do MMM';

            case 'list':
                return 'dddd, Do MMM YY';

            default:
                return formatFor;
        }
    }
}

export default CalendarConfig;